import { ObjectUtil } from './object.util';

export class StringUtil<T> {
	static capitalize(text: string) {
		return `${text.charAt(0).toUpperCase()}${text.slice(1).toLowerCase()}`;
	}

	static onlyNumber(text: string | number): string {
		return String(text).match(/\d/gi)?.join('') || '';
	}

	static snakeToCamel(str) {
		return str.toLowerCase().replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));
	}
}
